/**
 * @generated SignedSource<<3b9166c96a54f1a6074d7a8ca298f580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Locale = "EN" | "LT";
export type EditorTranslateButtonRefetchQuery$variables = {
  id: string;
  to: Locale;
  translate?: boolean | null;
};
export type EditorTranslateButtonRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_data">;
};
export type EditorTranslateButtonRefetchQuery = {
  response: EditorTranslateButtonRefetchQuery$data;
  variables: EditorTranslateButtonRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "translate"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditorTranslateButtonRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "translate",
            "variableName": "translate"
          }
        ],
        "kind": "FragmentSpread",
        "name": "EditorTranslateButton_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorTranslateButtonRefetchQuery",
    "selections": [
      {
        "condition": "translate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "to",
                "variableName": "to"
              }
            ],
            "kind": "ScalarField",
            "name": "translateTextBlock",
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b19a334ffc96a271b1e45215ad3d11eb",
    "id": null,
    "metadata": {},
    "name": "EditorTranslateButtonRefetchQuery",
    "operationKind": "query",
    "text": "query EditorTranslateButtonRefetchQuery(\n  $id: ID!\n  $to: Locale!\n  $translate: Boolean = false\n) {\n  ...EditorTranslateButton_data_4krjNH\n}\n\nfragment EditorTranslateButton_data_4krjNH on Query {\n  translateTextBlock(id: $id, to: $to) @include(if: $translate)\n}\n"
  }
};
})();

(node as any).hash = "d3989c8ff4a60ce25a5b098a05bf2419";

export default node;
